<template>
  <div>
  <IftttForm></IftttForm>
  </div>
</template>

<script>
import IftttForm from "@/components/ifttt/IftttForm.vue";

export default {
  name: "iftttAdd",
  components: {IftttForm}
}
</script>

<style scoped>

</style>